angular
  .module 'bookAndPay'
  .controller 'ProcessPaymentCtrl', (
    $scope,
    $rootScope,
    $state,
    $window,
    $http,
    $interval,
    DataService,
    Restangular,
    CreditCardExpirationDatesService,
    BookAndPayService,
    flash,
    cart
  ) ->
    $scope.cart = cart.plain()
    $scope.currency = DataService.currency
    $scope.years = CreditCardExpirationDatesService.getYears()
    $scope.months = CreditCardExpirationDatesService.getMonths()
    $scope.cartType = if cart.cart_type is 'payment_only_cart'
      'po'
    else
      undefined
    $scope.isIntegrapay = cart.realtime_payment_provider is 'integrapay'
    $scope.isEzidebit = cart.realtime_payment_provider is 'ezidebit'
    $scope.isStripe = cart.realtime_payment_provider is 'stripe'

    $scope.expired = BookAndPayService.isExpired($scope.cart)
    intervalId = $interval () ->
      $scope.expired = BookAndPayService.isExpired($scope.cart)
    , 1000

    $scope.$on '$destroy', () ->
      $interval.cancel intervalId

    $scope.setLoading = (loading) ->
      $scope.isLoading = loading
      if loading
        confirmText = 'Please wait while your payment is being processed.'
        $rootScope.stateChangeConfirmMessage = confirmText
        $window.onbeforeunload = (e) ->
          e.returnValue = confirmText
          confirmText
      else
        $rootScope.stateChangeConfirmMessage = undefined
        $window.onbeforeunload = undefined

    if $scope.isEzidebit
      $http.get("/fee_schedules?gym_id=#{DataService.gym_id}&for_book_and_pay=1").then (response) ->
        $scope.fees = response.data.fees

    $scope.displayTime = ->
      moment(cart.event_start_at, 'YYYY/MM/DD HH:mma')
        .format('ddd, D MMM [at] h:mm')

    $scope.toNewCart = ->
      $state.go 'bookAndPay.newCart', uuid: cart.membership_plan_uuid, ct: $scope.cartType

    $scope.cancelBooking = ->
      if $window.confirm "Are you sure you want to cancel your booking?"
        $scope.toNewCart()

    $scope.onPaymentsUnavailable = ->
      $scope.paymentsUnavailable = true
